import WizardTwo from "@/components/wizard/wizardTwo";
import { useLocale } from "@/contexts/localeContext";
import { TranslationKeys } from "@/contexts/TranslationKeys";
import WizardSideBarStep from "@/models/WizardSideBarStep";
import { FC, ReactElement, useState } from "react";
import Modal from "react-modal";
import Details from "./Details";
import Summary from "./Summary";
import { Form, Formik } from "formik";
import { storeOssDevice } from "@/services/ossDeviceService";
import { useDialog } from "@/components/dialog/DialogContext";
import { getErrorMessage } from "@/services/utilities/ServiceError";
import { toast } from "react-toastify";

interface InstallOssDeviceModalProps {
    isOpen: boolean;
    onClose: () => void;
    postInstall: () => void;
}

const InstallOssDeviceModal: FC<InstallOssDeviceModalProps> = ({ isOpen, onClose, postInstall }) => {
    const {translate} = useLocale();
    const dialog = useDialog();
    const [step, setStep] = useState<number>(0);
    const initialDevice = {
        id: 0,
        name: '',
        no: '',
        ossdType: "1",
    }
    const sidebardSteps: WizardSideBarStep[] = [
        {
            title: translate.byKey(TranslationKeys.details),
            description: "",
            substeps:[]
        },
        {
            title: translate.byKey(TranslationKeys.summary),
            description: "",
            substeps: []
        },
    ]

    const onNext = () => {
        setStep(prev => prev + 1);
    }

    const onBack = () => {
        setStep(prev => prev - 1);
    }

    const stepContent: ReactElement[] = [
        <Details onNext={onNext} key="details" />,
        <Summary onBack={onBack} key="summary" />
    ]
 
    const onInstall = (values: any) => {
        storeOssDevice(values).then((response) => {
            onClose();
            postInstall();
            toast.success(translate.byKey(TranslationKeys.installed))
        }).catch((error) => {
            dialog.pushError({ title: translate.byKey(TranslationKeys.error), message: getErrorMessage(error) });
        });
    }


    return <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        overlayClassName="flex w-screen position-float-modal fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
        className="bg-white border-none m-auto shadow select-none outline-none w-content">
        <Formik
            enableReinitialize={true}
            initialValues={initialDevice}
            onSubmit={onInstall}>
            <Form>
                <WizardTwo
                    name={translate.byKey(TranslationKeys.installOssDevice)}
                    step={step}
                    onClose={onClose}
                    sidebarSteps={sidebardSteps}
                    stepContent={stepContent}>
                </WizardTwo>
            </Form>
        </Formik>
    </Modal>
}

export default InstallOssDeviceModal;